<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-distribution-config`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 9a7 7 0 00-13.327-3H15.326A7 7 0 106 15.326v17.347A7 7 0 1015.326 42h17.348a7 7 0 109.327-9.327V15.327A7 7 0 0046 9zM36 39a3 3 0 116 0 3 3 0 01-6 0zM9 36a3 3 0 100 6 3 3 0 000-6zm6.929-25.999h16.142A7.005 7.005 0 0038 15.929v16.142A7.004 7.004 0 0032.07 38H15.93A7.005 7.005 0 0010 32.071V15.929a7.005 7.005 0 005.928-5.928zM24 15a9 9 0 110 18 9 9 0 010-18zm-5 9a5 5 0 1110 0 5 5 0 01-10 0zM39 6a3 3 0 100 6 3 3 0 000-6zM6 9a3 3 0 116 0 3 3 0 01-6 0z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconDistributionConfig',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
